import { FC } from 'react';

import { Button } from '@hh.ru/magritte-ui';
import { LineArrowRightEnterOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

import sessionLogout from 'components/Header/HeaderUserDrop/LogoutButton/sessionLogout';

const TrlKeys = {
    logout: 'Header.HeaderUserDrop.logout',
};

export const LogoutButton: FC<{ isAdminHeader?: boolean }> = ({ isAdminHeader = false }) => {
    const trls = useTrls();

    return (
        <Button
            mode="secondary"
            style={isAdminHeader ? 'constant' : 'negative'}
            size="small"
            stretched={!isAdminHeader}
            icon={<LineArrowRightEnterOutlinedSize16 />}
            spaceBetween
            onClick={() => sessionLogout()}
            data-qa="logout-link"
        >
            {trls(TrlKeys.logout)}
        </Button>
    );
};
